import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import * as moment from 'moment';
import { take } from 'rxjs/operators';
import { register } from 'src/app/dashboards/widget/widget-helpers/helpers';
import { BaseWebEngageReportsSettingsComponent } from 'src/app/reports/reports-details/nested-components/reports-web-engage-settings/base/base-web-engage-reports-settings.component';
import { reportSources } from 'src/app/reports/reports-list/reports-list.component';
import { CommonService } from 'src/app/services/services/common.service';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import { WidgetBaseComponent } from '../../widget-base.component';

@Component({
    selector: 'app-rule-match-wizard',
    templateUrl: './rule-match-wizard.component.html',
    styleUrls: ['./rule-match-wizard.component.scss'],
    standalone: false
})
@register("RuleMatch_wizard")
export class RuleMatchWizardComponent extends BaseWebEngageReportsSettingsComponent implements OnInit, WidgetBaseComponent {
  @Input() public isEdit: boolean;
  @Output() public completed = new EventEmitter<boolean>();

  columns: any[] = [];
  relativeFromCompleted: boolean = false;
  relativeToCompleted: boolean = false;
  calculatedFrom: Date = new Date();  
  calculatedTo: Date = new Date();

  constructor(protected dashboardsService: DashboardService, protected i18nextPipe: I18NextPipe, private commonService: CommonService,) {
    super(dashboardsService, i18nextPipe);
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.isEdit) {
      this.calculateDates();
      this.loadRulesAndInteractions(moment.utc().add(-2,"y").toDate(), moment.utc().toDate());
    } else {
      this.gridItem.setup = { period: { type: 1, toTime: "24:00", fromTime: "00:00" }, sysGroupByTime: ' ', limitRange: false, filters: {} };
    }

    this.dashboardsService.getReportByCode("RuleMatch", reportSources.WebEngage).pipe(take(1)).subscribe(report => {
      this.report = report;
      this.columns = report.allColumns;
      this.gridItem.setup.columns = this.columns.map(col => col.labelCode);
      this.gridItem.setup.reportId = report.id;
    })
  }

  notifyReportModified() {
    this.modelChange();
    super.notifyReportModified();
  }

  rulesModelChanged(selectedItemIds) {
    this.gridItem.setup.ruleIds = selectedItemIds;
    this.loadInteractions(selectedItemIds, this.calculatedFrom, this.calculatedTo);
    this.visualTypeCheck();
    this.notifyReportModified();
  }

  dateSelectChange() {
    if (this.relativeFromCompleted && this.relativeToCompleted) {
      this.calculateDates();
      this.setDisabledColumns(this.calculatedFrom, this.calculatedTo);


      this.loadRulesAndInteractions(this.calculatedFrom, this.calculatedTo);
    } else {
      this.ruleItems = [];
      this.interactionItems = [];
    }
    this.modelChange();
  }

  calculateDates() {
    let from = this.commonService.calculateRelativeDate("from", this.gridItem);
    let toTimeInMinutes = this.commonService.getRelativeDateTimeInMinutes("from", this.gridItem);
    from.add(toTimeInMinutes, "minutes");
    this.calculatedFrom = from.toDate();
    let to = this.commonService.calculateRelativeDate("to", this.gridItem);
    toTimeInMinutes = this.commonService.getRelativeDateTimeInMinutes("to", this.gridItem);
    to.add(toTimeInMinutes, "minutes");
    this.calculatedTo = to.toDate();
  }

  modelChange() {
    let setup = this.gridItem.setup;
    let isCompleted = true;

    this.visualTypeCheck();
    this.calculateDates();
    this.setDisabledColumns(this.calculatedFrom, this.calculatedTo);

    var keyColumns = this.columns?.filter(c => c.isKey).map(c => c.labelCode) || [];

    if (this.gridItem.type == null) isCompleted = false;
    if (setup.reportId == null) isCompleted = false;

    if (!setup.columns || setup.columns.length < keyColumns.length + 1) isCompleted = false;

    if (setup.period?.type == 0 && (!setup.period.from || !setup.period.to)) isCompleted = false;
    if (setup.period?.type == 1 && (!this.relativeFromCompleted || !this.relativeToCompleted)) isCompleted = false;
    this.completed.emit(isCompleted);
  }
}
